const exceptionServiceName = "/ConferenceRuleExecption"

export function conferenceExceptionService (http) {
    return {
        getAllVisibleSystemUsers: async (pageNumber, pageSize, sortBy, filters) => {
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));

            const filter=filters;
            const dataAttribute = {
                page:pageNumber,
                pageSize,
                sorts: newSort.lenght==0?[{member:"StartDate",sortDirection:"Ascending"}]:newSort,
                filter: filter
            }


            return await http.post(exceptionServiceName + "/GetAllVisibleSystemUsersAsync", dataAttribute);
        },
    }
}

